<template>
    <div class="tab">
        <div class="grid">
            <div v-if="curWidth > 780" class="column">
                <img :src="imgSrc"/>
            </div>
            <div class="column">
                <h1>{{name}}</h1>
                <h2>{{desc}}</h2>
                <ul>
                    <li v-for="item in array" :key="item"><span>→</span>{{item}}</li>
                </ul>
            </div>
            <div v-if="curWidth <= 780" class="column">
                <img :src="imgSrc"/>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: "Tab",
  props: ['name','array','imgSrc','desc','curWidth', 'leftright']
};
</script>

<style lang="scss" scoped>
.tab{
    margin-top: 15%;
    margin-bottom: 15%;
    @media(min-width: 780px){
        width: 70%;
        margin: 0 auto;
    }
    padding-top: 0.5%;
    .grid{
        @media(min-width: 780px){
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
        }
    }
    .column{
        flex: 1;
        img{
            max-width: 200px;
            @media(min-width: 780px){
                max-width: 350px;
            }
        }
        h1{
            font-size: 3rem;
            font-weight: bold;
            text-align: center;
            @media(min-width: 780px){
                padding: 5%;
                margin-left: 5%;
                text-align: left;
            }
        }
        h2{
            text-align: left;
            color: rgb(107,115,122);
            font-size: 1.1rem;
            text-align: justify;
            margin: 5% 5% 25px 5%;
            @media(min-width: 780px){
                padding: 5%;
                margin-top: 0;
            }
        }
        ul{
            li{
                text-align: left;
                padding: 1%;
                font-size: 1.1rem;
                color: rgb(107,115,122);
                span{
                    padding: 5%;
                    color: rgb(121,214,131);
                    font-weight: bold;
                    font-size: 1.1rem;
                }
            }
        }
    }
}
</style>
